import React from 'react';
import MultipleCatalogManager from './MultipleCatalogManager';

/**
 * Componente de compatibilidad - redirecciona al nuevo MultipleCatalogManager
 * Mantiene la misma API para no romper las rutas existentes
 */
const PrivateCatalogManager = (props) => {
    return <MultipleCatalogManager {...props} />;
};

export default PrivateCatalogManager;